// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3y4SQ","list":"PatternAutocomplete_list__3wJrL"};